module.exports = __webpack_public_path__ + "static/media/mobile-crown-check.2c3e65c4.svg";